import React, { useState } from 'react';
import './Styles.css';
import { Link, useNavigate } from 'react-router-dom';
import { registerWithEmailAndPassword } from './firebase';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';

// Declare firebaseConfig before using it
const firebaseConfig = {
  apiKey: "AIzaSyCP4g_6uBql4kMoC8Qoio_wnU9BiAxNreQ",
  authDomain: "jackpot-95e4b.firebaseapp.com",
  projectId: "jackpot-95e4b",
  storageBucket: "jackpot-95e4b.appspot.com",
  messagingSenderId: "170469651918",
  appId: "1:170469651918:web:3507b8c083ab792d29279f"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

const Registration = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  function navigateToSuccessfulRegistration(){
    console.log('registered');
    navigate('/');
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic form validation
    if (!name || !email || !password || !confirmPassword) {
      setError('Please fill in all fields');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      await registerWithEmailAndPassword(name, email, password);
      navigateToSuccessfulRegistration();
    } catch (error) {
      console.error(error);
      setError('Registration failed. Please try again.');
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      console.log('Signed in with Google:', user);
      navigateToSuccessfulRegistration();
      // Handle the signed-in user as needed (e.g., update UI, store user data)
    } catch (error) {
      console.error('Google Sign-In failed:', error);
    }
  };

  return (
    <div className='loginbottom'>
      <div className='formContainer'>
        <h4>Register</h4>
        <form onSubmit={handleSubmit}>
          <div>
            <label>Name:</label>
            <input type="name" value={name} onChange={handleNameChange} />
          </div>
          <div>
            <label>Email:</label>
            <input type="email" value={email} onChange={handleEmailChange} />
          </div>
          <div>
            <label>Password:</label>
            <input type="password" value={password} onChange={handlePasswordChange} />
          </div>
          <div>
            <label>Confirm Password:</label>
            <input type="password" value={confirmPassword} onChange={handleConfirmPasswordChange} />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit">Register</button>
        </form>
        <p>
          Already have an account? <Link to="/login">Login</Link> <br /> or
        </p>
        
        <center>
          <div className='google-div' onClick={handleGoogleSignIn}><img className='google' src="https://1000logos.net/wp-content/uploads/2016/11/Google-Symbol.png" alt="" /></div>
        </center>
      </div>
    </div>
  );
};

export default Registration;
